import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ParameterItem } from 'rte-core-app/lib/rte-parameter/models/parameter-item.model';

@Injectable({
  providedIn: 'root'
})
export class ParameterService {

  constructor(
    private http: HttpClient  ) { }

  getAllParameters(): Observable<ParameterItem[]> {
    return this.http.get<ParameterItem[]>(environment.apiUrl + 'api/parameter');
  }

  getParameterDescriptionMenu(value: string): Observable<ParameterItem> {
    return this.http.get<ParameterItem>(environment.apiUrl + 'api/parameter/getdescription?value=' + value);
  }
}
